import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PagesID } from "@utils/utilsConfigurations";
import EnrollmentListShell from "../components/EnrollmentListShell";
import UserEnrollmentRow from "../components/UserEnrollmentRow";
import { usePreEnrolledUsersList } from "../hooks/usePreEnrolledUsersList";

const PAGE_SIZE = 10;

interface PreEnrolledUsersTabProps {
  corporateId: string | number;
  objectId: number;
}

const PreEnrolledUsersTab: React.FC<PreEnrolledUsersTabProps> = ({
  corporateId,
  objectId,
}) => {
  const { t } = useTranslation("users-and-groups");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [fieldFilters, setFieldFilters] = useState<Record<string, any>>({});

  const { items, totalItems, totalPages, isLoading } = usePreEnrolledUsersList({
    corporateId,
    objectId,
    page,
    pageSize: PAGE_SIZE,
    search: search || undefined,
    fieldFilters,
  });

  return (
    <EnrollmentListShell
      search={search}
      onSearchSubmit={(v) => {
        setSearch(v);
        setPage(1);
      }}
      hideSearch
      filtersPageId={PagesID["corporate.catalog.activities.pre-registered"]}
      fieldFilters={fieldFilters}
      onApplyFilters={(next) => {
        setFieldFilters(next);
        setPage(1);
      }}
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel={String(t("empty.pre-enrolled-users"))}
      page={page}
      pageSize={PAGE_SIZE}
      totalItems={totalItems}
      totalPages={totalPages}
      onPageChange={setPage}
    >
      {items.map((user) => (
        <UserEnrollmentRow
          key={`${user.userId}-${user.enrollId ?? ""}`}
          user={user}
          // TODO: riattivare la freccia quando esisterà il detail enrollment
          // onArrowClick={(u) => navigate(...)}
        />
      ))}
    </EnrollmentListShell>
  );
};

export default PreEnrolledUsersTab;
